import { useTranslation } from "react-i18next"

import { useHeaderControlsContext } from "~/components/contexts/useHeaderControlsContext"

export const useBuildStandardsSorts = () => {
  const { t } = useTranslation("products")
  const { sorts, setSorts } = useHeaderControlsContext()
  return {
    sorts,
    setSorts,
    sortOptions: [
      { label: t("sorts.name"), value: "name" },
      { label: t("sorts.brandReference"), value: "brandReference" },
      { label: t("sorts.purchaseOrder"), value: "purchaseOrder" },
      { label: t("sorts.brand"), value: "brand" },
      { label: t("sorts.color"), value: "color" },
      { label: t("sorts.brandType"), value: "brandType" },
      { label: t("sorts.collection"), value: "collection" },
    ],
  }
}
